import { useQueryClient } from '@tanstack/react-query';

import { AppError } from '@/utils';

import { GlobalLetter } from '../types';

export const useGlobalLetterData = (): GlobalLetter => {
  const queryClient = useQueryClient();

  const globalLetterData = queryClient.getQueryData<GlobalLetter>([
    'globalLetter',
  ]);

  if (!globalLetterData) throw AppError.authError();

  return globalLetterData;
};
